import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import roboweek from "../../Assets/Projects/roboweek.png";
import hacktoberfest from "../../Assets/Projects/hacktoberfest.png";
import samepage from "../../Assets/Projects/samepage.png";
import escrew from "../../Assets/Projects/escrew.png";
import todo from "../../Assets/Projects/todo.png";
import calculator from "../../Assets/Projects/calculator.png";
import fire from "../../Assets/Projects/fire.jpeg";
import numb from "../../Assets/Projects/numb.png";
import ecom from "../../Assets/Projects/ecom.png";
import weat from "../../Assets/Projects/weat.png";
import urls from "../../Assets/Projects/urls.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={escrew}
              isBlog={false}
              title="ES-CREW"
              description="Developed a website that connects service seekers with service providers and provides various facilities in remote areas."
              ghLink="https://github.com/arora-jasjot/technocrat"
              demoLink="https://es-crew.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={calculator}
              isBlog={false}
              title="Calculator"
              description="Developed a calculator that can perform all the mathematical operations using CSS, EJS and Javascript."
              ghLink="https://github.com/Mridul07Sharma/LGMVIP-WEB-TASK-4"
              demoLink="https://mridul07sharma.github.io/LGMVIP-WEB-TASK-4/ "
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={samepage}
              isBlog={false}
              title="Registration Form"
              description="Developed a registration form using Node.js, EJS, MongoDB, Express whose data is sstored on a MongoDB database."
              ghLink="https://github.com/Mridul07Sharma/LGMVIP-WEB-TASK-3"
              // demoLink=""              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={roboweek}
              isBlog={false}
              title="Roboweek Website"
              description="Developed the website of Annual College Techfest using HTML, SCSS and Reactjs. "
              ghLink="https://drive.google.com/file/d/1hcupnqI1vUqcc0zfIRGh-FyXphGjDjpA/view"
              // demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="To-Do List"
              description="Developed a project that keeps the record of all the To-Dos using EJS, CSS and Javascript"
              ghLink="https://github.com/Mridul07Sharma/LGMVIP-Web-Task-1"
              // demoLink="" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hacktoberfest}
              isBlog={false}
              title="HacktoberFest 2022"
              description="Participated in Open Source Contribution Event and contributed to different repositories."
              ghLink="https://github.com/Mridul07Sharma/Algorithm"
              // demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fire}
              isBlog={false}
              title="Autonomous Fire Extinguisher"
              description="A Hardware project that automatically Detects fire using Fire sensors and smoke sensors and extinguishes the fire. Arduino uno is used as microcontroller."
              ghLink="https://github.com/Mridul07Sharma/autonFire"
              // demoLink=""     
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={numb}
              isBlog={false}
              title="Number Plate Detection"
              description="Developed an advanced machine vision project that is used to identify vehicles by their number plates without direct human intervention by using Open-CV. "
              ghLink="https://github.com/Mridul07Sharma/numberplate"
              // demoLink=""   
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecom}
              isBlog={false}
              title="E-Commerce Website"
              description="Built a dynamic and responsive e-commerce website using React.js and JavaScript, inspired by the functionality and design of Amazon. Implemented features such as product listings, shopping cart, user authentication, and payment integration."
              ghLink="https://github.com/Mridul07Sharma/amazon-clone"
              // demoLink=""   
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weat}
              isBlog={false}
              title="Weather App"
              description="WeatherApp is a user-friendly and reliable weather application developed using Rapid API and JavaScript. With a clean and intuitive interface, it provides real-time weather updates and forecasts for any location worldwide. Users can simply enter their desired location and instantly receive comprehensive weather information, including temperature, humidity, wind speed, and more."
              ghLink="https://github.com/Mridul07Sharma/weather-app"
              demoLink="https://weather-app-mridul.vercel.app/"   
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={urls}
              isBlog={false}
              title="URL Shortner"
              description="URL Shortener is a powerful tool developed using Express, Node.js, MongoDB, and JavaScript. It offers a seamless solution for converting long, cumbersome URLs into concise, easy-to-share links. With this application, you can quickly generate shortened URLs that are perfect for social media posts, emails, and any other situation where space is limited. "
              ghLink="https://github.com/Mridul07Sharma/urlShortner"
              demoLink="https://urlshortner-1y8s.onrender.com/"   
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
